import { useIsMobile } from "@shared/hooks/useIsMobile";
import InstructorIcon from "@svg/instructor";
import BookIcon from "@svg/new-design/book";
import Graduated from "@svg/new-design/graduated";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";

interface Props {
  id: number;
  full_name: string;
  profile_picture: string;
  url: string;
  slug: string;
  product_count: number;
  student_count: number;
  grade: string | null;
  university: string | null;
  degree: string;
  score: number;
}

const TeacherCard: FC<Props> = ({
  profile_picture,
  full_name,
  degree,
  product_count,
  student_count,
  url,
}) => {
  const isMobile = useIsMobile(640);
  return (
    <div className="rounded-8  relative border hover:border-fds-brand-light hover:shadow-brand-md active:border-fds-brand  border-fds-divider p-2  sm:p-3">
      <Link className="w-full" href={url} prefetch={false}>
        <div className="relative ">
          <div className="w-full  sm:h-16 h-11  overflow-hidden rounded-4">
            <Image
              src="https://faradars.org/wp-content/uploads/2024/12/02/bgteacherblue.svg"
              fill
              className="object-cover"
              alt="bgTeacher"
            />
          </div>
          <div className="absolute right-1 sm:right-2.5    sm:top-8 top-[22px] overflow-hidden rounded-full sm:w-14 sm:h-14 w-9 h-9">
            {profile_picture ? (
              <Image src={profile_picture} alt={full_name} fill />
            ) : (
              <InstructorIcon
                width={isMobile ? 35 : 55}
                height={isMobile ? 35 : 55}
              />
            )}
          </div>
        </div>

        <div className="mt-4     sm:mt-6">
          <p className="sm:title-lg title-sm text-fds-primary sm:line-clamp-1 sm:h-6  line-clamp-2 h-11  ">
            {full_name}
          </p>
          <p className="sm:body-md body-xsm text-fds-primary h-10 sm:h-7 line-clamp-2 sm:line-clamp-1">
            {degree !== "word.profile_degree. " ? degree : ""}
          </p>
          <div className="mt-1">
            <div className="flex items-center sm:body-xsm body-xxsm gap-1 sm:gap-1.5  text-fds-secondary  ">
              <BookIcon className="h-4     w-4     sm:h-5    sm:w-5" />
              <span>
                {separateMoneyNumbers(toFarsiNumber(product_count))} آموزش
              </span>
            </div>
            {student_count ? (
              <div className="flex items-center sm:body-xsm body-xxsm gap-1 mt-1 sm:gap-1.5  text-fds-secondary ">
                <Graduated className="h-4     w-4     sm:h-5    sm:w-5" />
                <span>
                  {separateMoneyNumbers(toFarsiNumber(student_count)) || ""}{" "}
                  دانشجو
                </span>
              </div>
            ) : (
              <br />
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};
export default TeacherCard;
